import { cva } from "class-variance-authority";
/**
 * Error banner container styles
 */
export const errorBannerVariants = cva("flex items-center gap-3 w-full", {
    variants: {},
    defaultVariants: {},
});
//# sourceMappingURL=error-banner.styles.js.map